// Flag to prevent multiple attempts to open the cart drawer
let openingCart = false;

// Function to handle the "Add to Cart" button click
function handleAddToCart(event) {
    event.preventDefault();

    if (openingCart) return;

    const button = event.target.closest('.addtocart');
    const form = button.closest('.product-form');
    const quantityInput = form.querySelector('.ajaxcart__qty-num');
    const productId = form.querySelector('[name="id"]').value;

    let adjustedQuantity = parseInt(quantityInput.value) || 1;

    console.log('Adjusted quantity:', adjustedQuantity); // Log the adjusted quantity

    const formData = new FormData();
    formData.append('id', productId);
    formData.append('quantity', adjustedQuantity);

    // Set the flag to indicate that the cart drawer is being opened
    openingCart = true;

    // Send an AJAX request to add the product to the cart
    fetch('/cart/add.js', {
        method: 'POST',
        body: formData
    })
        .then(response => response.json())
        .then(data => {
            // Handle the response if needed
            console.log('Product added to cart:', data);

            // Trigger the opening of the cart drawer if it's not already open
            const cartDrawerLink = document.querySelector('.js-drawer-open-right-link');
            if (cartDrawerLink && !isDrawerOpen()) {
                cartDrawerLink.click();
            }
        })
        .catch(error => {
            console.error('Error adding product to cart:', error);
        })
        .finally(() => {
            openingCart = false;
        });
}

// Function to check if the cart drawer is open
function isDrawerOpen() {
    const cartDrawer = document.querySelector('#CartDrawer');
    return cartDrawer && cartDrawer.getAttribute('aria-expanded') === 'true';
}

// Attach event listener to the document for event delegation
document.addEventListener('click', function(event) {
    if (event.target && event.target.classList.contains('addtocart')) {
        console.log('Add to cart button clicked');
        handleAddToCart(event);
    }
});

